import { BaseRequest } from '../../../../../shared/models/base-request.model';
import { Attachment } from '../../../../../../app/front-user/shared/models/attachment.model';
import { SmallUnitService } from 'src/app/admin/e-services/small-units/shared/models/small-units-service.model';

export class SmallUnitRequest {

    RequestorId: string;
    StatusId: number;
    Id: string;
    UnitName: string;
    UnitTypeId: number;
    RegisterNo: string;
    NationalityId: number;
    Length: number;
    Depth: number;
    Width: number;
    NetTonnage: number;
    GrossTonnage: number;
    SCNetTonnage: number;
    SCGrossTonnage: number;
    ArrivalDate: string;
    LastTransitDate: string;
    CrewNo: number;
    DirectionId: number;
    FromCountryId: number;
    ToCountryId: number;
    SelectedCurrencyId: number;
    SmallUnitReviewActionId: number;
    SmallUnitMoreInformation: string;
    MeasEstimationActionId: number;
    EstimatedFeesValue: number;
    EstimatedNetTonnage: number;
    EstimatedSDR: number;
    MeasEstimationMoreInformation: string;
    MeasEstimationRejectReason: string;
    MarineActionId: number;
    ActualArrivalTime: string;
    MarineCancelationReason: string;
    MeasActualActionId: number;
    ActualLength: number;
    ActualWidth: number;
    ActualDepth: number;
    ActualSCNT: number;
    ActualSCGT: number;
    MeasActualRejectReason: string;
    Swift: string;
    ConfirmedDocument: boolean;
    AgentTransitDate: string;
    SmallUnitTransitActionId: number;
    SmallUnitTransitDate: string;
    SmallUnitTransitMoreInformation: string;
    ISActionId: number;
    ISNotes: string;
    ISMarineActionId: number;
    ISMarineNotes: string;
    SmallUnitConfirmActionId: number;
    SmallUnitConfirmTransitDate: string;
    SmallUnitConfirmMoreInformation: string;
    ISMarineConfirmActionId: number;
    ISMarineConfirmTransitDate: string;
    ISMarineConfirmMoreInformation: string;
    FinalSDR: number;
    InitialSDRDate: Date;
    FinalTransitFeesValue: number;
    FinalTotalFees: number;
    LocalEquiv: number;
    TotalFeesLE: number;
    InvoiceNo: string;
    InvoiceDate: string;
    InvoiceAccountantName: string;
    InvoiceAuditorName: string;
    IsFinalFeesReview: boolean;
    BaseRequestDTO: BaseRequest;
    Attachments: Attachment[] = [];
    SmallUnitServices: SmallUnitService[] = [];
    ISMActionId: number;
    ISMNotes:string;
    ISMActualArrivalTime:string
    // ISMSmallUnitTransitActionId: number;
    ISMSmallUnitTransitDate: string;
    ISMSmallUnitTransitMoreInformation: string;
    ISMDepartureNotes: string;
    IsPostedToSCA: boolean;
};